import { defineComponent, useSlots, computed, createElementBlock, openBlock, normalizeClass, createCommentVNode, createElementVNode, renderSlot, createVNode, Transition, withCtx } from 'vue';
import { useSlotContent } from './basler-components.es425.js';

const _hoisted_1 = {
  key: 0,
  class: "search-page-layout__breadcrumb"
};
const _hoisted_2 = {
  class: "search-page-layout__content",
  "aria-live": "polite"
};
const _hoisted_3 = {
  key: 0,
  class: "search-page-layout__search-box"
};
const _hoisted_4 = ["inert"];
const _hoisted_5 = {
  key: 0,
  class: "search-page-layout__initial-content"
};
const _hoisted_6 = { class: "search-page-layout__initial-content-inner" };
const _hoisted_7 = {
  key: 1,
  class: "search-page-layout__search-content"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "SearchPageLayout",
  props: {
    searchDropdownIsOpen: { type: Boolean },
    showResults: { type: Boolean, default: false }
  },
  setup(__props) {
    const slots = useSlots();
    const { hasSlotContent } = useSlotContent();
    const hasBreadcrumbSlotContent = computed(() => {
      return hasSlotContent(slots.breadcrumb);
    });
    const hasSearchBoxSlotContent = computed(() => {
      return hasSlotContent(slots["search-box"]);
    });
    const hasInitialContentSlotContent = computed(() => {
      return hasSlotContent(slots["initial-content"]);
    });
    const hasSearchContentSlotContent = computed(() => {
      return hasSlotContent(slots["search-content"]);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["search-page-layout", { "is-search-dropdown-open": _ctx.searchDropdownIsOpen }])
      }, [
        hasBreadcrumbSlotContent.value ? (openBlock(), createElementBlock("div", _hoisted_1, [
          renderSlot(_ctx.$slots, "breadcrumb")
        ])) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_2, [
          hasSearchBoxSlotContent.value ? (openBlock(), createElementBlock("div", _hoisted_3, [
            renderSlot(_ctx.$slots, "search-box")
          ])) : createCommentVNode("", true),
          createElementVNode("div", {
            class: "search-page-layout__content-results",
            inert: _ctx.searchDropdownIsOpen ? true : void 0
          }, [
            createVNode(Transition, {
              name: "search-page-layout-transition",
              mode: "out-in"
            }, {
              default: withCtx(() => [
                hasInitialContentSlotContent.value && !_ctx.showResults ? (openBlock(), createElementBlock("div", _hoisted_5, [
                  createElementVNode("div", _hoisted_6, [
                    renderSlot(_ctx.$slots, "initial-content")
                  ])
                ])) : hasSearchContentSlotContent.value && _ctx.showResults ? (openBlock(), createElementBlock("div", _hoisted_7, [
                  renderSlot(_ctx.$slots, "search-content")
                ])) : createCommentVNode("", true)
              ]),
              _: 3
            })
          ], 8, _hoisted_4)
        ])
      ], 2);
    };
  }
});

export { _sfc_main as default };
